<template>
  <div>
    <b-modal
      id="detail-flow-approval-modal"
      no-close-on-backdrop
      size="lg"
      title="Detail Flow Approval"
    >
      <b-row>
        <b-col cols="12" xl="12">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Jenis Modul</span></th>
                <td>{{ result.moduleType }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Implementasi Flow</span></th>
                <td>{{ result.roleImplement ? result.roleImplement.roleName : '-' }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Total Approval</span></th>
                <td>{{ result.totalApproval ? result.totalApproval : '-' }}</td>
              </tr>
              
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { BCol, BAvatar, BRow } from "bootstrap-vue";

export default {
  components: {
    BCol,
    BAvatar,
    BRow,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["result"],
};
</script>
